// extracted by mini-css-extract-plugin
export default {"root":"classes_root__8ZiJ+","background":"classes_background__U8V+d","modal":"classes_modal__3Ywwy","title":"classes_title__a-7Mx","separator":"classes_separator__zqMxU"};